interface Props {
  coverImageUrl: string | null
  propertyName: string
  guestName: string | null
  checkoutDayOfWeek: string | null
  checkinTime: string | null
  checkoutTime: string | null
  wifiName: string | null
  weatherLine: string | null
  bookingPhase: string | null
  /** Voice-aware stay line template with {property} and {day} placeholders. */
  stayLineTemplate?: string
  /** Voice-aware checkout nudge text. Falls back to "Safe travels!". */
  checkoutNudge?: string
}

export function HeroSlide({
  coverImageUrl,
  propertyName,
  guestName,
  checkoutDayOfWeek,
  checkinTime,
  checkoutTime,
  wifiName,
  weatherLine,
  bookingPhase,
  stayLineTemplate,
  checkoutNudge,
}: Props) {
  const isBetween = bookingPhase === "between_bookings"
  const isCheckout = bookingPhase === "checkout" || bookingPhase === "last_evening"

  // Build the compact info fragments
  const infoFragments: string[] = []
  if (checkinTime) infoFragments.push(`${checkinTime} check-in`)
  if (wifiName) infoFragments.push(`WiFi: ${wifiName}`)
  if (checkoutTime) infoFragments.push(`Checkout ${checkoutTime}`)
  const infoLine = infoFragments.join(" \u00B7 ")

  // Stay line: voice-aware template with {property} and {day} placeholders
  const stayLine =
    !isBetween && checkoutDayOfWeek
      ? (stayLineTemplate || "{property} is yours until {day}")
          .replace("{property}", propertyName)
          .replace("{day}", checkoutDayOfWeek)
      : null

  // Greeting
  const greeting = isBetween
    ? propertyName
    : guestName
      ? `Welcome, ${guestName}`
      : propertyName

  if (isBetween) {
    return (
      <div className="tv-hero tv-hero--ambient">
        {coverImageUrl ? (
          <div className="tv-hero__image-zone tv-hero__image-zone--full">
            <img src={coverImageUrl} alt="" className="tv-hero__image" />
          </div>
        ) : (
          <div className="tv-hero__image-zone tv-hero__image-zone--full tv-hero__image-zone--dark" />
        )}
        <div className="tv-hero__ambient-overlay">
          <h1 className="tv-hero__ambient-name">{propertyName}</h1>
          {weatherLine && <p className="tv-hero__ambient-weather">{weatherLine}</p>}
        </div>
      </div>
    )
  }

  return (
    <div className={`tv-hero ${!coverImageUrl ? "tv-hero--no-image" : ""}`}>
      {coverImageUrl && (
        <div className="tv-hero__image-zone">
          <img src={coverImageUrl} alt="" className="tv-hero__image" />
        </div>
      )}
      <div className="tv-hero__text-zone">
        <div className="tv-hero__text-inner">
          <h1 className="tv-hero__greeting">{greeting}</h1>
          {stayLine && <p className="tv-hero__stay-line">{stayLine}</p>}
          {!isBetween && infoLine && <p className="tv-hero__info-line">{infoLine}</p>}
          {isCheckout && <p className="tv-hero__checkout-nudge">{checkoutNudge || "Safe travels!"}</p>}
          {weatherLine && <p className="tv-hero__weather-line">{weatherLine}</p>}
        </div>
      </div>
    </div>
  )
}
